import { Fill, Stroke, Style } from "ol/style";

export const DefaultStyle = new Style({
  fill: new Fill({
    color: "rgba(255, 255, 255,0)",
  }),
  stroke: new Stroke({
    color: "rgba(0, 0, 0,)",
    lineDash: [10, 10],
    width: 2,
  }),
});

export const FieldStyle = new Style({
  fill: new Fill({
    color: "#E5E5E5",
  }),
  stroke: new Stroke({
    width: 1,
    color: "black",
    lineDashOffset: 20,
  }),
});
